export const employmentTypeOptions = [
  {
    label: '全職',
    value: 'full-time',
  },
  {
    label: '兼職(含打工)',
    value: 'part-time',
  },
  {
    label: '實習',
    value: 'intern',
  },
  {
    label: '臨時工',
    value: 'temporary',
  },
  {
    label: '約聘雇',
    value: 'contract',
  },
  {
    label: '派遣',
    value: 'dispatched-labor',
  },
];

export const salaryTypeOptions = [
  {
    label: '年薪',
    value: 'year',
  },
  {
    label: '月薪',
    value: 'month',
  },
  {
    label: '日薪',
    value: 'day',
  },
  {
    label: '時薪',
    value: 'hour',
  },
];

export const overallRatingDialogMap = {
  1: '差',
  2: '普通',
  3: '不錯啦～',
  4: '很好！',
  5: '大推！',
};
